import React from 'react'
import imgStampingCapabilities from "../../imagens/stamping/imgStampingCapabilities.png"
import { Link } from 'react-router-dom'
import logoToolings from "../../imagens/logos/logoToolings.png"
import imgMoldes from "../../imagens/moldes/imgMolde.png"


const ToolingAndManufacturing = () => {
    return (
        <div>
            <div className="text-start mb-2 ms-2">
                <img className="img-fluid img-custom-size" src={logoToolings} alt="Capabilities Logo" />
            </div>
            <div className="container-fluid p-5">
                <div className="customrow w-100 justify-content-around">
                    <div className="custom-width col-md-2 col-sm-3 mb-4 hover-custom">
                        <Link className="text-decoration-none" to="/Capabilities/Engineering/StampingTool">
                            <img src={imgStampingCapabilities} className="img-fluid" alt="Stamping Capabilities" />
                            <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Stamping progressive tooling</h2>
                        </Link>
                    </div>
                    <div className="custom-width col-md-2 col-sm-3 mb-4 hover-custom">
                        <Link className="text-decoration-none" to="/Capabilities/Engineering/Molds">
                            <img src={imgMoldes} className="img-fluid" alt="Test Capabilities" />
                            <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Injection molds</h2>
                        </Link>
                    </div>
                    {/* <div className="custom-width col-md-2 col-sm-3 mb-4 hover-custom">
                        <Link className="text-decoration-none" to="/Capabilities/Engineer/MultiComponetsCapabilities">
                            <img src={imgMoldes} className="img-fluid" alt="Plastic Capabilities" />
                            <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Multi Components</h2>
                        </Link>
                    </div>
                    <div className="custom-width col-md-2 col-sm-3 mb-4 hover-custom">
                        <Link className="text-decoration-none" to="/Capabilities/Engineer/prototypeFabricationCapabilities">
                            <img src={imgMoldes} className="img-fluid" alt="Welding Capabilities" />
                            <h2 className="textCapabilities text-wrap text-center mt-2  fs-md-5"> Prototype Fabrications</h2>
                        </Link>
                    </div> */}
                </div>
            </div>
            <div className="text-center my-4">
                <Link to="/Capabilities">
                    <button className="buttonCapabilities">Back to Capabilities</button>
                </Link>
            </div>
        </div>
    );
}
export default ToolingAndManufacturing